module.exports = __webpack_public_path__ + "static/media/turbo-wins-logo.765553e3.png";